import { useContext } from "react";

import { ItemPropertiesActions, ItemPropertiesContextDispatch } from "components/OptionsWizard/ItemProperties/ItemPropertiesContext";

export function useItemPropertiesActions(): ItemPropertiesActions {
    return useContext(ItemPropertiesContextDispatch)!;
};

export default useItemPropertiesActions;
